// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getSubscriptionDataProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetSubscriptionProfessionalApi = createAsyncThunk(
  "hitGetSubscriptionProfessionalApi",
  async (token=null) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")? localStorage.getItem("professionalToken") : token}`,
        },
        params: {
          //search,
        },
      };
      const url = ApiBaseUrl + getSubscriptionDataProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetSubscriptionProfessionalSlice = createSlice({
  name: "getSubscriptionProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetSubscriptionData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetSubscriptionProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetSubscriptionProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetSubscriptionProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetSubscriptionData } = GetSubscriptionProfessionalSlice.actions;
export default GetSubscriptionProfessionalSlice.reducer;
